import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackSiteVisit } from '@/services/analytics';

export default function VisitorTracking() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (!/^\/admin(?:\/|$)/.test(pathname)) void trackSiteVisit();
  }, [pathname]);
  return null;
}
